import React from 'react';
import SEO from '../../components/SEO/SEO';
import SubServiceTemplate from '../../components/SubServiceTemplate/SubServiceTemplate';

const MetaAds = () => {
  const pageData = {
    category: "META ADS",
    title: "Meta Ads Management (Facebook & Instagram)",
    description: "Reach billions of users with precision-targeted Meta campaigns. Our Meta Ads specialists create thumb-stopping creatives and data-driven strategies that turn social engagement into measurable business results.",

    features: [
      {
        title: "Advanced Audience Targeting",
        description: "Leverage Meta's powerful targeting options including custom audiences, lookalikes, and interest-based segments to reach your ideal customers."
      },
      {
        title: "Creative Testing & Optimization",
        description: "A/B test ad creatives, copy, and formats to identify what resonates with your audience and maximize engagement."
      },
      {
        title: "Dynamic Product Ads",
        description: "Automated retargeting campaigns that show users the exact products they viewed, dramatically increasing conversion rates."
      },
      {
        title: "Carousel & Story Ads",
        description: "Immersive ad formats that tell your brand story and showcase multiple products in engaging, mobile-first experiences."
      },
      {
        title: "Retargeting Campaigns",
        description: "Strategic remarketing to website visitors, engaged users, and cart abandoners to recover lost sales and boost ROI."
      },
      {
        title: "Performance Analytics",
        description: "Comprehensive tracking of ROAS, CPA, engagement metrics, and attribution across the entire customer journey."
      }
    ],

    benefits: [
      {
        title: "Massive Reach",
        description: "Access 3+ billion active users across Facebook and Instagram to scale your brand globally."
      },
      {
        title: "Precise Targeting",
        description: "Reach users based on demographics, interests, behaviors, and even life events with unmatched accuracy."
      },
      {
        title: "Lower Acquisition Costs",
        description: "Strategic optimization reduces CPA while increasing conversion volume and overall profitability."
      },
      {
        title: "Visual Storytelling",
        description: "Leverage image, video, and carousel formats to create emotional connections with your audience."
      }
    ],

    process: [
      {
        title: "Audience Research & Strategy",
        description: "Deep dive into your target market, competitor analysis, and customer personas to build winning targeting strategies."
      },
      {
        title: "Creative Development",
        description: "Design scroll-stopping ad creatives with compelling copy, visuals, and clear calls-to-action that drive results."
      },
      {
        title: "Campaign Launch & Testing",
        description: "Deploy multi-variant campaigns with structured testing frameworks to identify top performers quickly."
      },
      {
        title: "Optimization & Scaling",
        description: "Continuously refine targeting, bidding, and creative based on performance data to maximize ROI and scale winners."
      }
    ],

    relatedServices: [
      {
        title: "Google Ads",
        description: "Capture high-intent search traffic with Google Ads campaigns",
        link: "/services/paid-ads/google-ads"
      },
      {
        title: "TikTok Ads",
        description: "Reach younger audiences with viral TikTok ad campaigns",
        link: "/services/paid-ads/tiktok-ads"
      },
      {
        title: "LinkedIn Ads",
        description: "Target B2B decision-makers with LinkedIn advertising",
        link: "/services/paid-ads/linkedin-ads"
      }
    ],

    ctaText: "Let's create Meta campaigns that drive real revenue. Book a free strategy session today.",
    ctaLink: "/contact",
    parentLink: "/services/paid-ads",
    parentTitle: "Paid Ads"
  };

  return (
    <>
      <SubServiceTemplate {...pageData} />
      
            <SEO 
                title="Meta Ads Services" 
                description="Learn more about our Meta Ads services to grow your business online with Digi Network." 
                canonical="/paid-ads/meta-ads" 
            />

    </>
  );
};

export default MetaAds;
